<template src="./template.html"></template>
<script>
import moment from 'moment'
import Datepicker from 'vuejs-datepicker'
import { mapState } from 'vuex'

import InventoryList from 'components/InventoryList'
import dateUtils from 'utils/dateUtils'

export default {
  name: 'inventory-list-with-date-picker',
  props: {
    shouldLockDate: {
      type: Boolean,
    },
    eventId: {
      type: String,
    },
    inventoryType: {
      type: String,
    },
    hideTickets: {
      type: Boolean,
      default: false,
    },
    disableInlineCheckout: {
      type: Boolean,
      default: false,
    },
    checkoutUrl: {
      type: String,
    },
    //THEMEING
    theme: {
      type: String,
      default: 'theme-light',
    },
  },
  data() {
    return {
      inventory: [],
      datePickerDisabledOptions: {
        to: null,
        from: null,
      },
    }
  },
  computed: {
    ...mapState({
      date: (state) => state.date.current,
      venue: (state) => state.venue.current,
      //
      attributionId: (state) => state.config.attributionId,
      affiliateId: (state) => state.config.affiliateId,
      trackingId: (state) => state.config.trackingId,
      client: (state) => state.config.client,
    }),
    utcDate() {
      return this.date ? dateUtils.toUTCDateWithoutTime(this.date) : ''
    },
  },
  methods: {
    closeDatePicker() {
      this.$refs.datePicker.close()
    },
    onInventoryListUpdated() {
      this.$emit('updated')
    },
    onInventorySelected(data) {
      if (!data) throw new Error('data is required')
      if (!data.inventory || data.inventory.quantityLeft < 1) return

      const options = {
        venueId: this.venue.id,
        inventory: data.inventory,
        inventoryQuantity: data.inventoryQuantity,
        attributionId: this.attributionId,
        client: this.client,
      }

      this.$emit('scrollTop')

      this.$emit('inventorySelected', options)
    },
    onDatepickerSelected(newDate) {
      const date = dateUtils.toUTCMomentWithoutTime(newDate)

      this.$store.dispatch('setCurrentDate', date)
    },
    onDatepickerOpened() {
      this.$emit('datePickerOpened')
    },
    onDatepickerClosed() {
      this.$emit('updated')
    },
  },
  components: {
    Datepicker,
    InventoryList,
  },
  created() {
    const maxDate =
      this.venue && this.venue.inventoryTimeframe
        ? moment()
            .utc()
            .add(this.venue.inventoryTimeframe - 1, 'day')
        : null

    this.datePickerDisabledOptions.to = moment.utc().subtract(1, 'day').toDate()
    this.datePickerDisabledOptions.from = maxDate ? maxDate.toDate() : null
  },
  updated() {
    this.$emit('updated')
  },
}
</script>



// WEBPACK FOOTER //
// src/components/InventoryListWithDatePicker/index.vue